import React, { useEffect,useState } from "react";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import { useAuth } from "component/UseAuth";
import axios from "axios";
import { pdf  } from "@react-pdf/renderer";
import MyReportCoA from "component/utils/MyReportCoA";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";

function RChartOfAccount() {
  const { user } = useAuth();
  const [loadingCoA, setLoadingCoA] = useState(false);

  useEffect(() => {
      document.title = "Green Hill Kemuning | Chart of Account";
      window.scrollTo(0, 0);
  }, []);

const handleDownloadCoA = async () => {
  try {
    setLoadingCoA(true);
    const reg_desc = user?.company;

    const res = await axios.post(
      `${process.env.REACT_APP_API}/report-coa`,
      { reg_desc }
    );

    const jsonData = res.data.data;

    // 🔽 Generate PDF dan auto-download
    const blob = await pdf(
      <MyReportCoA data={jsonData} userBy={user?.name || "Admin"} />
    ).toBlob();

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Laporan_Chart_of_Account.pdf";
    a.click();
    URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Gagal mengambil data CoA:", err);
    showError("Gagal mengambil data Chart of Account.");
  } finally {
    setLoadingCoA(false);
  }
};
      
  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                  <div class="row px-4">
                      <div class="card shadow p-3">
                        <div class="card-body">
                          <div class="row">
                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="card-title m-0">Chart of Account Management</h5>
                            </div>
                          </div>
                        </div>  
                        <div class="row px-4 mt-3">
                          <div class="card shadow p-3 mb-4">
                            <div class="card-body d-flex justify-content-between align-items-center">
                              <h6 class="mb-0">Chart of Account</h6>
                              <>
                                <button className="btn btn-success" onClick={handleDownloadCoA}>
                                  {loadingCoA ? "Loading..." : "Download"}
                                </button>
                              </>
                            </div>
                          </div>

                          <div class="card shadow p-3 mb-4">
                            <div class="card-body">
                              <h6 class="mb-3">Neraca / Laba Rugi</h6>
                              <div class="d-flex align-items-center flex-wrap gap-3">
                                <div class="form-check form-check-inline m-0">
                                  <input class="form-check-input" type="radio" name="reportType1" id="neraca1" value="neraca" />
                                  <label class="form-check-label" htmlFor="neraca1">Neraca</label>
                                </div>
                                <div class="form-check form-check-inline m-0">
                                  <input class="form-check-input" type="radio" name="reportType1" id="labaRugi1" value="labaRugi" />
                                  <label class="form-check-label" htmlFor="labaRugi1">Laba Rugi</label>
                                </div>
                                <div class="ms-auto">
                                  <button class="btn btn-primary me-2">Tampilkan</button>
                                  <button class="btn btn-success">Download</button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="card shadow p-3 mb-4">
                            <div class="card-body">
                              <h6 class="mb-3">Neraca / Laba Rugi per Cabang / Reg.</h6>
                              <div class="row align-items-center">
                                <div class="col-md-4 d-flex align-items-center">
                                  <div class="form-check form-check-inline me-3 mb-0">
                                    <input class="form-check-input" type="radio" name="reportType2" id="neraca2" value="neraca" />
                                    <label class="form-check-label" htmlFor="neraca2">Neraca</label>
                                  </div>
                                  <div class="form-check form-check-inline mb-0">
                                    <input class="form-check-input" type="radio" name="reportType2" id="labaRugi2" value="labaRugi" />
                                    <label class="form-check-label" htmlFor="labaRugi2">Laba Rugi</label>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <select class="form-select">
                                    <option selected disabled>Pilih Cabang / Reg.</option>
                                    <option value="cabang1">Cabang 1</option>
                                    <option value="cabang2">Cabang 2</option>
                                  </select>
                                </div>

                                <div class="col-md-4 text-end">
                                  <button class="btn btn-primary me-2">Tampilkan</button>
                                  <button class="btn btn-success">Download</button>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>    
    </div>
  );
}

export default RChartOfAccount;
